/**
 *  1 - Request API para recuperar loginNumbers
 *  2 - Tratar erros
 *  3 - Exibir tela de Adicionar número caso não haja loginNumbers
 *  4 - Exibir tela para Alterar / Excluir Número
 *
 *
 */
import React, { useContext, useEffect, useState } from "react";
import { Text } from "mondrian-react";
import MainTitle from "components/MainTitle";
import Analytics from "core/Utils/Analytics";
import Button from "components/Button";
import InputControl from "components/InputControl";
import ButtonGroup from "components/ButtonGroup";
import Input from "components/Input";
import FormContainer from "components/FormContainer";
import Fieldset from "components/Fieldset";
import Legend from "components/Legend";
import { store } from "store";
import { useStep } from "react-hooks-helper";
import { deleteMsisdn } from "core/api/loginNumbers/LoginNumbersApi";
import GenericTokenValidate from "pages/TokenValidate/GenericTokenValidate";
import Success from "pages/Success";
import { useHistory } from "react-router-dom";
export default function ExcluirNumero({ setForm, formData, ...props }) {
  const steps = [
    { id: "adicionar" },
    { id: "validar-token" },
    { id: "success" },
  ];
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const [tabCount, setTabCount] = useState(0);
  const [firstTab, setFirstTab] = useState(false);
  const { step, navigation } = useStep({ initialStep: 0, steps });
  const { id } = step;
  const { accesstoken, user = {} } = state;
  const {
    userData: currentUserData = "",
    selectedMsisdn,
    selectedMsisdnText,
  } = user;
  const { currentFlow } = state.analytics;
  const [inputMsisdn, setInputMsisdn] = useState("");
  const [inputMsisdnValid, setInputMsisdnValid] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();
  useEffect(function () {
    dispatch({
      type: "SET_GA",
      payload: { currentFlow: "desativar-numero-login" },
    });
    Analytics().setVirtualPageView(
      "/meuperfil/acesso-pelo-celular/desativar-numero"
    );
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();

    props.setIsLoading(true);
    let submitData = {
      userData: currentUserData,
      idDeleteNumber: selectedMsisdn,
    };
    let result = await deleteMsisdn(submitData, accesstoken);

    const error = result?.error;

    if (error != null) {
      const { message, originalMessage = message } = error.warning;
      props.setModalContent(error);
      Analytics().setErrorEvent({
        eventAction: `callback:${currentFlow}`,
        eventLabel: originalMessage,
        code: error?.errorCode
      });
      props.setIsLoading(false);

      return null;
    } else {
      Analytics().setSuccesEvent({
        eventAction: `callback:${currentFlow}`,
      });
      navigation.go("success");
      props.setIsLoading(false);
    }
  }

  function onFocusHandle(e) {
    if (tabCount >= 1) {
      console.clear();
      setFirstTab(true);
    }
    setTabCount(tabCount + 1);
    props.firstTab = firstTab;
  }

  const onKeyDown = (e) => {
    if (e.key === "Tab" && !firstTab) {
      e.preventDefault();
      const el = document.getElementById("mdn-Header");
      if (el) document.getElementById("mdn-Header").focus();
    }
  };

  switch (id) {
    case "success":
      return (
        <Success
          {...props}
          firstTab={firstTab}
          title="Número desativado com sucesso."
        >
          <Text>
            Caso desejar, você pode ativar uma nova linha a qualquer momento.
          </Text>
          <ButtonGroup>
            <Button
              tabIndex="21"
              secondary
              onClick={() => history.push("/meuperfil")}
            >
              Retornar ao Meu Perfil
            </Button>
            <Button
              tabIndex="22"
              onFocus={onFocusHandle}
              onKeyDown={onKeyDown}
              onClick={() => history.push("/meuperfil/acesso-pelo-celular")}
            >
              Ativar nova linha
            </Button>
          </ButtonGroup>
        </Success>
      );
    default:
      return (
        <>
          <FormContainer>
            <MainTitle sm>Acesso pelo celular</MainTitle>
            <Legend>
              <Text>
                Este é o número que está ativo para você realizar o login pelo
                seu celular.
              </Text>
              <Text>Tem certeza que deseja desativar este número?</Text>
            </Legend>
            <Fieldset>
              <InputControl>
                <Input
                  name="msisdn"
                  id="msisdn"
                  label="Celular"
                  value={selectedMsisdnText}
                  disabled
                  text
                  tabIndex="20"
                />
              </InputControl>
              <div className="mp-button-group">
                <Button
                  type="button"
                  secondary
                  onClick={() => props.navigation.go("info")}
                  tabIndex="21"
                >
                  Voltar
                </Button>
                <Button
                  type="submit"
                  tabIndex="22"
                  onClick={(e) => handleSubmit(e)}
                >
                  Avançar
                </Button>
              </div>
            </Fieldset>
          </FormContainer>
        </>
      );
  }
}
